import React, { useState } from "react";
import {
  headerBodyWrapper, headerTextIcon,
  link, textLinks, linkGroupWrapper, linkGroup,
  socialIcons, linksWrapper, productGroupContainer, productContent, prodImageTitle,
  prodImage, prodTitleBadge, accordionIcon, accordionIconOpen, pdpTitle,
  singleProuctInfo, prodTitleBadgeGroup, badgeContainer, newCategoryPage, categoryPage,
  categoryLinksContainer, navigation, menuItems, categoryTitle, singleMenuItem, imgTitle,
  backBtn, category, closeBtn, itemContainer
} from "./body.mod.scss";
import SwiperCore, { Pagination } from "swiper";
import locales from "locales";
import facebookIcon from "assets/images/social/fb.svg";
import instagramIcon from "assets/images/social/insta.svg";
import pinterestIcon from "assets/images/social/pint.svg";
import Link from "components/link";
import locale from "locales";
import getImagePath from "helpers/get-image-path";
import { ChevronDown } from "react-bootstrap-icons";
import RightArrow from "src/assets/svgs/right-arrow.svg";
import LeftArrow from "src/assets/svgs/left-arrow.svg";
import XIcon from "src/assets/svgs/x-icon.svg";
import { trackMenuClick } from "helpers/analytics";

SwiperCore.use([Pagination]);

const Menu = ({ content }) => {
  const [showDropdownMenu, setShowDropdownMenu] = useState(false);


  return (
    <div className={prodTitleBadge}>
      <div className={productContent} onClick={() => { setShowDropdownMenu(!showDropdownMenu); }}>

        <div className={prodTitleBadgeGroup}>
          <p>{content.title}</p>
          {content?.badge &&
            <div className={badgeContainer}>
              <img src={getImagePath(content?.badge)} alt={content?.badge?.alt} />
            </div>
          }
        </div>
        <span className={!showDropdownMenu ? accordionIcon : accordionIconOpen}><ChevronDown /></span>
      </div>
      {showDropdownMenu &&
        content?.productInfo?.map((prodData, i) => <div key={i} className={singleProuctInfo}>
          <Link to={prodData?.link}>
            <div className={prodImageTitle}>
              <div className={prodImage}>
                <img src={getImagePath(prodData?.image)} alt={prodData?.image?.alt} />
              </div>
              <p className={pdpTitle}>{prodData?.title}</p>
              <span className={headerTextIcon} />
            </div>
          </Link>
        </div>)
      }
    </div>
  );
};

const ProductGroup = ({ data }) => {
  const productGroupData = data?.link?.find((dt) => dt?._type === "menuGroup");
  return (
    <div className={productGroupContainer}>
      {productGroupData?.productCategory?.map((content, i) => (
        <Menu content={content} key={i} />
      ))};
    </div>
  );
};

const CategoryNewPage = ({
  content,
  toggleMenuHeader,
  handleCategoryMenuClose,
  handleCategoryMenuOpen,
}) => {
  const [newPage, setNewPage] = useState(0);
  const [selectedCategory, setSelectedCategory] = useState("");
  const [subcategory, setSubcategory] = useState(0);
  const back = locales?.account?.nav?.back;

  const handlePageClick = () => {
    setNewPage(content?._key);
    setSelectedCategory(content?.title);
    handleCategoryMenuOpen(true);
  };

  const handleBackClick = () => {
    setNewPage(0);
    handleCategoryMenuClose(false);
  };

  const handleMenuHeaderClick = () => {
    toggleMenuHeader();
    setNewPage(0);
  };

  const renderSingleMenuItem = (item) => (
    <div key={item?._key} onClick={() => setSubcategory(item?._key)} className={singleMenuItem}>
      <Link to={item?.link} className={itemContainer} onClick={() => trackMenuClick({
        url: item?.link, title: item?.title
      })}>
        <div className={imgTitle}>
          <img src={getImagePath(item?.image)} alt={item?.image?.alt} />
          <p>{item?.title}</p>
        </div>
        <RightArrow />
      </Link>
    </div>
  );

  const renderMenuItems = () => (
    <>
      {subcategory === 0 &&
        content?.productInfo?.map((item) => renderSingleMenuItem(item))}
      {content?.productInfo?.map((item) =>
        subcategory === item?._key && item?.subcategory?.length > 0 && (
          <SubcategoryPage key={item?._key} item={item} />
        )
      )}
    </>
  );

  const SubcategoryPage = ({ item }) => (
    <>
      {item?.subcategory?.length > 0 && (
        <div className={newCategoryPage}>
          <div className={navigation}>
            <p className={backBtn} onClick={() => setSubcategory(0)}>
              <LeftArrow />
              {back}
            </p>
            <p className={category}>{item?.title}</p>
            <p className={closeBtn} onClick={handleMenuHeaderClick}>
              <XIcon />
            </p>
          </div>
          <div className={menuItems}>
            {subcategory === item?._key &&
              item?.subcategory?.map((singleProd, j) => (
                <div className={singleMenuItem} key={j}>
                  <Link to={singleProd?.link} className={itemContainer} onClick={() => trackMenuClick({
                    url: singleProd?.link, title: singleProd?.title
                  })}>
                    <div className={imgTitle}>
                      <img src={getImagePath(singleProd?.image)} alt={singleProd?.image?.alt} />
                      <p>{singleProd?.title}</p>
                    </div>
                    <RightArrow />
                  </Link>
                </div>
              ))}
          </div>
        </div>
      )}
    </>
  );

  return (
    <>
      <div className={categoryPage}>
        {content?._type === "directLink" ? (
          <Link to={content?.url} key={content?._key}
            onClick={() => trackMenuClick(content)}>
            <p className={categoryTitle}>
              {content?.title} <RightArrow />
            </p>
          </Link>
        ) : (
          <p className={categoryTitle} key={content?._key} onClick={() => {
            handlePageClick();
            trackMenuClick(content);
          }}>
            {content?.title} <RightArrow />
          </p>
        )}
      </div>

      {newPage === content?._key && (
        <div className={newCategoryPage}>
          <div className={navigation}>
            <p className={backBtn} onClick={handleBackClick}>
              <LeftArrow />
              {back}
            </p>
            <p className={category}>{selectedCategory}</p>
            <p className={closeBtn} onClick={handleMenuHeaderClick}>
              <XIcon />
            </p>
          </div>
          <div className={menuItems}>{renderMenuItems()}</div>
        </div>
      )}
    </>
  );
};

const CategoryLinks = ({
  data,
  toggleMenuHeader,
  handleCategoryMenuOpen,
  handleCategoryMenuClose,
}) => {
  const categoryLinks = data?.link?.find((dt) => dt?._type === "menuGroup");

  const renderCategoryNewPages = () => (
    categoryLinks?.productCategory?.map((content, i) => (
      <CategoryNewPage
        content={content}
        key={i}
        toggleMenuHeader={toggleMenuHeader}
        handleCategoryMenuOpen={handleCategoryMenuOpen}
        handleCategoryMenuClose={handleCategoryMenuClose}
      />
    ))
  );

  return <div className={categoryLinksContainer}>{renderCategoryNewPages()}</div>;
};



// Only Text Links Component
const TextLinks = ({ data }) => {
  const groupData = data.link.filter((dt) => dt._type === "groupLink");

  const Links = groupData.map((lnkGroup) => {
    const groupLinks = lnkGroup.links.map((lnk) => (<Link key={lnk._key} className={link} to={lnk.url} onClick={() => trackMenuClick(lnk)}>{lnk.title}</Link>));
    return (
      <div key={lnkGroup._key} className={linkGroupWrapper}>
        <span className={linkGroup}>{lnkGroup.title}</span>
        {groupLinks}
      </div>
    );
  });

  return (
    <div className={textLinks}>
      {Links}
    </div>
  );
};

const HeaderBody = ({ headerData, socialData, toggleMenuHeader }) => {
  const menuData = headerData.hamburgerMenus;
  const categoryLinks = menuData?.link?.find((dt) => dt?._type === "menuGroup");
  const categoryNewPage = categoryLinks?.categoryNewPage;
  const [isCategoryMenuOpen, setCategoryMenuOpen] = useState(false);

  const handleCategoryMenuOpen = () => {
    setCategoryMenuOpen(true);
  };

  const handleCategoryMenuClose = () => {
    setCategoryMenuOpen(false);
  };

  return (
    <div className={headerBodyWrapper}>
      {!categoryNewPage ?
        <ProductGroup data={menuData} /> :
        <CategoryLinks data={menuData} toggleMenuHeader={toggleMenuHeader}
          handleCategoryMenuOpen={handleCategoryMenuOpen}
          handleCategoryMenuClose={handleCategoryMenuClose} />}
      {!isCategoryMenuOpen &&
        <div className={linksWrapper}>
          <TextLinks data={menuData} />
        </div>}
      {!isCategoryMenuOpen &&
        <div className={socialIcons}>
          <Link to={socialData.facebook} target="_blank" rel="noreferrer" onClick={() => trackMenuClick({
            link: socialData?.facebook, title: "Facebook"
          })}>
            <img src={facebookIcon} alt={locale.altText.facebookIcon} />
          </Link>
          <Link to={socialData.instagram} target="_blank" rel="noreferrer" onClick={() => trackMenuClick({
            link: socialData?.instagram, title: "Instagram"
          })}>
            <img src={instagramIcon} alt={locale.altText.instagramIcon} />
          </Link>
          <Link to={socialData.pinterest} target="_blank" rel="noreferrer" onClick={() => trackMenuClick({
            link: socialData?.pinterest, title: "Pinterest"
          })}>
            <img src={pinterestIcon} alt={locale.altText.pinterestIcon} />
          </Link>
        </div>}
    </div>
  );
};

export default HeaderBody;